export enum TEACHING_TEAM_MEMBER_TYPE {
  PLATFORM_TEACHER = "platform_teacher",
  EXTERNAL = "external",
}
